import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { CheckRadioComponent } from './components';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
    ],
    declarations: [
        CheckRadioComponent,
    ],
    exports: [
        CheckRadioComponent,
    ],
})

export class CheckRadioModule {}
